import { ChangeDetectionStrategy, Component } from "@angular/core";
@Component({
    selector: "dtm-ui-triangle-pointer-svg",
    templateUrl: "./triangle-pointer.component.svg",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrianglePointerSvgComponent {}
